export default "__VITE_ASSET__mOvAsbfA__"